import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { DateTime } from 'luxon';
import { HttpService } from '../http.service';

@Component({
  selector: 'app-emails-sms',
  templateUrl: './emails-sms.component.html',
  styleUrls: ['./emails-sms.component.scss']
})
export class EmailsSmsComponent implements OnInit {

  fromDate: any;
  toDate: any;

  constructor(
    private http: HttpService,
  ) { }
  displayColumns = [
    "slno",
    "subject",
    "template",
    "to",
    "status",
  ];
  isdata: any;
  supportDetails: MatTableDataSource<any>;


  ngOnInit() {
    let currendateTime: any = DateTime.local().minus({ days: 7 });
    this.fromDate = new Date(currendateTime);
    this.toDate = new Date();
    this.getEmails();
  }
  getEmails() {
    const payload = {
      from_date: DateTime.fromJSDate(this.fromDate).startOf("day").toUTC(),
      to_date: DateTime.fromJSDate(this.toDate).endOf("day").toUTC(),
    };
    this.http.get('v1/reports/getMessageAuditLogCarrier', payload, 2).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.supportDetails = data.data;
          this.isdata = data.data.length;
          console.log(this.isdata);
        }
      }
    )
  }

}
